import axios from 'axios'
import config from '@/config'
import interceptorResponseSuccess from '@/services/interceptors/response-success'
import interceptorResponseError from '@/services/interceptors/response-error'
import interceptorRequestPost from '@/services/interceptors/request-post'

axios.defaults.withCredentials = true
const http = axios.create({
  baseURL: config.API_URL
})

http.interceptors.response.use(interceptorResponseSuccess, interceptorResponseError, interceptorRequestPost)
http.interceptors.request.use(interceptorRequestPost)

const httpRedirect = axios.create({
  baseURL: config.REDIRECT_URL
})

httpRedirect.interceptors.response.use(interceptorResponseSuccess, interceptorResponseError, interceptorRequestPost)
httpRedirect.interceptors.request.use(interceptorRequestPost)

export { http, httpRedirect }



// WEBPACK FOOTER //
// ./src/services/http.js